
export const availableTagEntries = [
  'Add',
  'Adjective',
  'Adverb',
  'Business',
  'Expression',
  'Food',
  'General',
  'Poetry',
  'Verb',
  'Untagged'
];
